import { createAction, props } from '@ngrx/store';
import { AIVendorFeedbackFromCL } from '../../models/validation-status.model';

export const sendAIVendorFeedback = createAction(
    '[VAL QUEUE] Send AI Vendor Feedback',
    props<{ aiVendorFeedback: AIVendorFeedbackFromCL }>()
);
export const sendAIVendorFeedbackSuccess = createAction('[VAL QUEUE] Send AI Vendor Feedback Success');
export const sendAIVendorFeedbackFailure = createAction(
    '[VAL QUEUE] Send AI Vendor Feedback Failure',
    props<{ error: any }>()
);
